import React from 'react';

function RedTopNav({ item, iconStyle, href, color }) {
  return (
    <div className={`flex ${iconStyle} `}>
      <a href={href} target="_blank" rel="noopener noreferrer" className={`${color}`}>
        {item}
      </a>
    </div>
  );
}

export default RedTopNav;
